module.exports = __webpack_public_path__ + "media/images/icons/flags/EC-3b56a8a3ffe2bb9f23bb6d9de8cd20db.svg";